export const setReduxMessages = (messages) => ({ type: 'MSG_SET_MESSAGES', messages });
export const setReduxMessage = (message) => ({ type: 'MSG_SET_MESSAGE', message });

export const clearReduxMessages = () => ({ type: 'MSG_CLEAR_MESSAGES' });
export const clearReduxMessage = (clearMessage) => ({ type: 'MSG_CLEAR_MESSAGE', clearMessage });
